import styled from "styled-components";
import { colorStyle } from "styled-system";

export const Component = styled.li`
  ${colorStyle}
`;
